import { render, staticRenderFns } from "./SourceCodePage.vue?vue&type=template&id=bfee5e5c&scoped=true&"
import script from "./SourceCodePage.vue?vue&type=script&lang=js&"
export * from "./SourceCodePage.vue?vue&type=script&lang=js&"
import style0 from "./SourceCodePage.vue?vue&type=style&index=0&id=bfee5e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfee5e5c",
  null
  
)

export default component.exports